import apiClient from '@/services/AccountClient'
import { HEADER_SKIP_AUTOEXTEND } from '@/services/ApiClient/ApiClient'

export default {
  fetchAll (params = {}, options) {
    const defaultSort = 'updatedAt,desc'

    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/payments',
      {
        ...params,
        sort: [].concat(params.sort, defaultSort)
      },
      options
    )
  },
  fetchCounters (options) {
    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/payments/operations-count',
      null,
      {
        headers: { [HEADER_SKIP_AUTOEXTEND]: true },
        ...options
      }
    )
  },
  fetchPostponedSwiftCounter (options) {
    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/payments/postponed-swift-count',
      null,
      {
        headers: { [HEADER_SKIP_AUTOEXTEND]: true },
        ...options
      }
    )
  },
  fetchById (id, params = {}) {
    return apiClient.sendRequest(
      'GET',
      `api/admin/v1/payments/${id}`,
      params
    )
  },
  create (data) {
    return apiClient.sendRequest(
      'POST',
      'api/admin/v1/payments',
      data
    )
  },
  updateAmlComment (id, amlComment) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payments/${id}/aml/comment`,
      { amlComment }
    )
  },
  markAsDocumentsRequested (id) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payments/${id}/aml/request-docs`
    )
  },
  assignByAml (id) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payments/${id}/aml/assign`
    )
  },
  unassignByAml (id) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payments/${id}/aml/unassign`
    )
  },
  acceptByAml (id) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payments/${id}/aml/accept`
    )
  },
  acceptForManualReturnByAml (id) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payments/${id}/supervisor/accept-for-manual-return`
    )
  },
  rejectByAml (id, data) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payments/${id}/aml/reject`,
      data
    )
  },
  resyncAccuityStatusByAml (id) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/payments/${id}/aml/accuity-resync`
    )
  },
  returnToHoldBySupervisor (id) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payments/${id}/supervisor/hold`
    )
  },
  returnSepaBySupervisor (id) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payments/${id}/supervisor/sepa/return`
    )
  },
  forceToSepaBySupervisor (id) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payments/${id}/supervisor/force-to-sepa`
    )
  },
  forceToSwiftByAccountant (id) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payments/${id}/accountant/force-to-swift`
    )
  },
  cancelPostponedSwiftByAccountant (id) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payments/${id}/accountant/cancel-postponed-swift`
    )
  },
  returnToOnHoldPostponedSwiftByAccountant (id) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payments/${id}/accountant/return-to-on-hold-postponed-swift`
    )
  },
  updateBankSwiftBySupervisor (id, bankSwift) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payments/${id}/supervisor/bank-swift`,
      { bankSwift }
    )
  },
  changeChannelByAccountant (id, channel) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payments/${id}/accountant/change-channel`,
      { channel }
    )
  },
  changeChannelBySupervisor (id, channel) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payments/${id}/supervisor/change-channel`,
      { channel }
    )
  },
  verifyByAccountant (id) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/payments/${id}/accountant/verify`
    )
  },
  identifyRecipientByAccountant (id, data) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/payments/${id}/accountant/identify-recipient`,
      { ...data }
    )
  },
  verifyIdentifiedRecipientByAccountant (id) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/payments/${id}/accountant/verify-identified-recipient`
    )
  },
  awaitForVerificationByAccountant (id) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/payments/${id}/accountant/await-for-verification`
    )
  },
  canCreateAutoSwift (id) {
    return apiClient.sendRequest(
      'GET',
      `api/admin/v1/payments/${id}/accountant/can-create`
    )
  },
  forceToAutoSwift (id) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payments/${id}/accountant/force-to-auto-swift`
    )
  },
  forcePostponedAutoSwiftByAccountant (id, valueDate) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payments/${id}/accountant/force-postponed-auto-swift`,
      { valueDate }
    )
  },
  settleByAccountant (id, data) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/payments/${id}/accountant/settle`,
      data
    )
  },
  settleSwiftReturnByAccountant (id, data) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/payments/${id}/accountant/settle-swift-return`,
      data
    )
  },
  updateCommentByAccountant (id, comment) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payments/${id}/accountant/comment`,
      { comment }
    )
  },
  cancelByAccountant (id) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payments/${id}/accountant/cancel`
    )
  },
  cancelSwiftTopUpByAccountant (id, feeAmount, feeCurrency) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payments/${id}/accountant/cancel-swift-top-up`,
      { feeAmount, feeCurrency }
    )
  },
  cancelSettleSwiftTopUpDuplicateByAccountant (id) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payments/${id}/accountant/cancel-swift-top-up-duplicate`
    )
  },
  cancelByCardDepartment (id) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payments/${id}/card-department/cancel`
    )
  },
  retrySepaInstantWithdrawalByAccountant (id) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payments/${id}/accountant/retry-via-sct`
    )
  },
  retrySepaReturnByAccountant (id) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payments/${id}/accountant/retry-return-via-sct`
    )
  },
  retrySwiftFinWithdrawalByAccountant (id) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payments/${id}/accountant/retry-swift-withdrawal`
    )
  },
  retrySwiftFinReturnByAccountant (id) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payments/${id}/accountant/retry-swift-return`
    )
  },
  retryIfastApiWithdrawalByAccountant (id) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payments/${id}/accountant/retry-ifast-api`
    )
  },
  returnIfastApiWithdrawalToPendingByAccountant (id) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payments/${id}/accountant/return-ifast-api-to-pending`
    )
  },
  convertCancelByAccountant (id) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payments/${id}/accountant/currency-conversion/cancel`
    )
  },
  fetchSepaTopupReturnData (paymentId) {
    return apiClient.sendRequest(
      'GET',
      `api/admin/v1/payments/${paymentId}/return-data`
    )
  },
  createSepaTopupReturn (paymentId, amount) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/payments/${paymentId}/return`,
      { amount }
    )
  },
  rejectSepaTopupReturnRequest (paymentId, reason) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/payments/${paymentId}/return/reject`,
      { reason }
    )
  },
  fetchOperationsById (paymentId) {
    return apiClient.sendRequest(
      'GET',
      `api/admin/v1/payments/${paymentId}/operations`
    )
  },
  returnFeeOperation (paymentId, operationId, comment) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/payments/${paymentId}/operations/${operationId}/return`,
      { comment }
    )
  },
  cancelSepaWithdrawalOperation (paymentId, operationId, reason) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/payments/${paymentId}/operations/${operationId}/request-sepa-withdrawal-cancelation`,
      { reason }
    )
  },
  updateAmlTrackingMark (id, trackingMark) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payments/${id}/aml/tracking-mark`,
      { trackingMark }
    )
  },
  updateTransferChargeTypeByAccountant (id, transferChargeType) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payments/${id}/accountant/set-charge-type`,
      { transferChargeType }
    )
  },
  sendSepaNonreceiptClaim (paymentId, data) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/payments/${paymentId}/sepa/investigation/claim-of-non-receipt`,
      data
    )
  },
  sendSepaDateCorrectionClaim (paymentId, data) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/payments/${paymentId}/sepa/investigation/request-to-modify-payment`,
      data
    )
  },
  sendRespondToSepaClaim (paymentId, data) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/payments/${paymentId}/sepa/investigation/resolution`,
      data
    )
  }
}
